export const FETCH_PROFILE_DATA = "FETCH_PROFILE_DATA"
export const FETCH_PROFILE_ERROR_MESSAGE = "FETCH_PROFILE_ERROR_MESSAGE"
export const UPDATE_PROFILE_PICTURE = "UPDATE_PROFILE_PICTURE"
export const UPDATE_PROFILE_DATA = "UPDATE_PROFILE_DATA"
